module.exports = __webpack_public_path__ + "img/phone-screen-erik.96a5a115.jpg";